import { Component } from '@angular/core';
import { DwQueryFilterGroup, DwQueryHelper } from '@devwareapps/devware-cap';
import { PilotExaminerEntity, CheckrideRequestHomePageQueryEntity } from '../../../../meta-data/app-meta-data.service';
import { map, mergeMap, takeUntil } from 'rxjs/operators';
import { HomeCheckrideRepositoryService } from '../../../shared/services/home-checkride-repository.service';
import { ExaminerDashboardComponent } from '../examiner-dashboard/examiner-dashboard.component';
import { ExaminerRepositoryService } from '../../services/examiner-repository.service';
import { ExaminerTaskService } from '../../services/examiner-task.service';

import * as moment_ from 'moment';
const moment = moment_;

/** Examiner data and KPI scope for the shared inline home dashboard. */
@Component({
  selector: 'app-examiner-home',
  templateUrl: './examiner-home.component.html',
  styleUrls: ['./examiner-home.component.scss']
})
export class ExaminerHomeComponent extends ExaminerDashboardComponent {
  protected loadMetarData = false;

  examinerFirstName = '';
  kpiScopeFilters: DwQueryFilterGroup;
  homeCheckrides: CheckrideRequestHomePageQueryEntity[] = [];

  constructor(
    private homeExaminerRepository: ExaminerRepositoryService,
    examinerTaskService: ExaminerTaskService,
    private homeCheckrideRepository: HomeCheckrideRepositoryService
  ) {
    super(homeExaminerRepository, examinerTaskService);
  }

  loadExaminerStats(): void {
    this.loading = true;
    this.homeExaminerRepository.getCurrentPiloxExaminerStats(false, true).pipe(
      mergeMap(examiner => this.homeCheckrideRepository.load('examiner', examiner?.PilotExaminerId)
        .pipe(map(checkrides => ({ examiner, checkrides })))),
      takeUntil(this.destroy$)
    ).subscribe(({ examiner, checkrides }) => {
      if (!examiner) {
        this.errorMessage = 'Your examiner profile could not be loaded.';
        this.loading = false;
        return;
      }
      this.homeCheckrides = checkrides;
      this.pilotExaminer = { ...examiner, ScheduledCheckRideRequest: checkrides };
      this.buildExaminerTasks(this.pilotExaminer, this.showAll);
      this.onExaminerStatsLoaded(examiner);
      this.loading = false;
    }, () => {
      this.errorMessage = 'The examiner dashboard could not be loaded. Please refresh to try again.';
      this.loading = false;
    });
  }

  protected onExaminerStatsLoaded(examiner: PilotExaminerEntity): void {
    this.kpiScopeFilters = null;
    if (examiner?.PilotExaminerId) {
      this.kpiScopeFilters = new DwQueryFilterGroup();
      this.kpiScopeFilters.AddFilterAnd(new DwQueryHelper().filters.Equal(
        'roCheckrideFactBase.PilotExaminerId', examiner.PilotExaminerId));
      const yearStart = moment().startOf('year');
      const filters = new DwQueryHelper().filters;
      this.kpiScopeFilters.AddFilterAnd(filters.GreaterThanEqual(
        'roCheckrideFactBase.CheckrideDateTime', yearStart.format('YYYY-MM-DD')));
      this.kpiScopeFilters.AddFilterAnd(filters.LessThan(
        'roCheckrideFactBase.CheckrideDateTime', yearStart.clone().add(1, 'year').format('YYYY-MM-DD')));
    }
    this.examinerFirstName = examiner?.DwUser?.FirstName || '';
  }
}
